import { render, staticRenderFns } from "./LicenseAlert.vue?vue&type=template&id=398f59d5&"
import script from "./LicenseAlert.vue?vue&type=script&lang=js&"
export * from "./LicenseAlert.vue?vue&type=script&lang=js&"
import style0 from "./LicenseAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB03-CV-02\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('398f59d5')) {
      api.createRecord('398f59d5', component.options)
    } else {
      api.reload('398f59d5', component.options)
    }
    module.hot.accept("./LicenseAlert.vue?vue&type=template&id=398f59d5&", function () {
      api.rerender('398f59d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/LicenseAlert.vue"
export default component.exports